import { render, staticRenderFns } from "./paymentOfficialAccount.vue?vue&type=template&id=b474059e"
import script from "./paymentOfficialAccount.vue?vue&type=script&lang=js"
export * from "./paymentOfficialAccount.vue?vue&type=script&lang=js"
import style0 from "./paymentOfficialAccount.vue?vue&type=style&index=0&id=b474059e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports